import React, {PureComponent} from 'react';
import TranslatedText from '../../atoms/TranslatedText';

export default class TruBridgePeople extends PureComponent {
    render() {
        const {people, index} = this.props;
        return (
            <div className="TruBridgePeople">
                <div className="TruBridgePeople-bridge">
                    <img src={people.bridge} alt="" />
                    <div className="TruBridgePeople-bridge-label">
                        {index + 1}
                    </div>
                </div>
                <div className="TruBridgePeople-face">
                    <img src={people.image} alt="" />
                </div>
                <div className="TruBridgePeople-label">
                    <TranslatedText tag={people.label} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/trueBridge/TruBridgePeople.js